import { render, staticRenderFns } from "./PointOfServiceEditService.vue?vue&type=template&id=2b08594a&"
import script from "./PointOfServiceEditService.vue?vue&type=script&lang=ts&"
export * from "./PointOfServiceEditService.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VBtn,VContainer,VForm})
